export default "__VITE_ASSET__DDBNeJ6N__"